export default function itemPlannerInfoDialogCtrl($scope, $mdDialog) {
    $scope.close = () => {
        $mdDialog.hide();
    };
}

itemPlannerInfoDialogCtrl.$inject = [
    '$scope',
    '$mdDialog',
];
